import * as React from 'react';
import { clsx } from 'clsx';
import { parseDescriptionList } from "../index/utils";

type Props = Readonly<{
	description?: string,
	className?: string,
}>

/*
	Renders a Resa product description. The text is written by hand in the vendor's
	admin, so it is never trusted as markup — it is parsed into lines and rendered
	as React children, which escapes it.

	A description with no bullets falls back to a plain paragraph rather than being
	forced into a one-item list.
 */
function ProductDescription({description, className}: Props) {
	if (!description) {
		return null;
	}

	const parsed = parseDescriptionList(description);

	if (parsed === null) {
		return <p className={clsx(className, 'whitespace-pre-line')}>{description}</p>;
	}

	return (<>
		{parsed.intro.map((line, indexLine) => <p key={indexLine} className={className}>{line}</p>)}

		<ul className={className}>
			{parsed.items.map((item, indexItem) => <li key={indexItem}>
				{item.label !== null && <><strong>{item.label}:</strong>{' '}</>}{item.text}
			</li>)}
		</ul>
	</>);
}

export default ProductDescription;
